import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-dc39c0fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-3 px-3 min-vh-50" }
const _hoisted_2 = {
  key: 0,
  class: "merch-container"
}
const _hoisted_3 = { class: "col-12 col-md-6 merch-container-image" }
const _hoisted_4 = { class: "merch-container-image-item mx-0 me-lg-5" }
const _hoisted_5 = {
  key: 0,
  id: "carouselpc-product",
  class: "carousel slide"
}
const _hoisted_6 = { class: "carousel-indicators" }
const _hoisted_7 = ["data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "carousel-inner" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  src: _imports_0,
  class: "image-item",
  alt: "product"
}
const _hoisted_14 = { class: "col-12 col-md-6 merch-container-info" }
const _hoisted_15 = { class: "merch-container-info-name" }
const _hoisted_16 = {
  key: 0,
  class: "merch-container-info-price"
}
const _hoisted_17 = {
  key: 1,
  class: "merch-container-info-price-discounted"
}
const _hoisted_18 = { class: "merch-container-info-price discounted" }
const _hoisted_19 = { class: "merch-container-info-price" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "merch-container-info-alert" }, "Per gli ordini effettuati dopo il 18 Dicembre non è garantita la consegna entro Natale", -1))
const _hoisted_21 = {
  key: 2,
  class: "merch-container-info-few-remaining"
}
const _hoisted_22 = {
  key: 3,
  class: "merch-container-info-few-remaining"
}
const _hoisted_23 = {
  key: 4,
  class: "merch-container-info-buttons"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 5,
  class: "merch-container-info-options"
}
const _hoisted_29 = ["onClick", "onKeydown"]
const _hoisted_30 = {
  key: 6,
  class: "merch-container-info-options"
}
const _hoisted_31 = ["onClick", "onKeydown"]
const _hoisted_32 = {
  key: 7,
  class: "merch-container-info-options"
}
const _hoisted_33 = ["onClick", "onKeydown"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "merch-container-info-shipment" }, [
  /*#__PURE__*/_createElementVNode("span", null, "😌"),
  /*#__PURE__*/_createElementVNode("span", { class: "weight" }, [
    /*#__PURE__*/_createTextVNode("Spedizione gratuita a partire da "),
    /*#__PURE__*/_createElementVNode("u", null, "35€")
  ])
], -1))
const _hoisted_35 = {
  key: 8,
  class: "merch-container-info-weight"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🏋", -1))
const _hoisted_37 = { class: "weight" }
const _hoisted_38 = {
  key: 9,
  class: "merch-container-info-description"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "✍", -1))
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = {
  key: 10,
  class: "merch-container-info-material"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🧵", -1))
const _hoisted_43 = {
  key: 11,
  class: "merch-container-info-size-guide"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "👕", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-link weight",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_guide_size"
}, "Guida taglia", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 12,
  class: "merch-container-info-shipment"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🚚", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "weight" }, "Spedizione in 3 - 5 giorni lavorativi", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "merch-container-info-actions" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🧙", -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Pre ordina")
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "merch-container-can-like" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "merch-container-can-like-title" }, "Potrebbe piacerti anche", -1))
const _hoisted_57 = {
  key: 0,
  class: "merch-products-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchItem = _resolveComponent("MerchItem")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.product)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              ($setup.images.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, ix) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: ix,
                          type: "button",
                          "data-bs-target": "#carouselpc-product",
                          "data-bs-slide-to": ix,
                          class: _normalizeClass((ix === 0 ? 'active' : '')),
                          "aria-current": ix === 0,
                          "aria-label": 'Slide ' + ix.toString()
                        }, _hoisted_9, 10, _hoisted_7))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, ix) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: ix,
                          class: _normalizeClass(["carousel-item", (ix === 0 ? 'active' : '')])
                        }, [
                          _createElementVNode("img", {
                            src: $setup.getSrc(ix),
                            class: "d-block image-item",
                            alt: ""
                          }, null, 8, _hoisted_11)
                        ], 2))
                      }), 128))
                    ])
                  ]))
                : ($setup.images.length === 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: $setup.getSrc(0),
                      class: "image-item",
                      alt: "product"
                    }, null, 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("img", _hoisted_13))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString($setup.name), 1),
            (!$setup.idDiscounted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "€ " + _toDisplayString($setup.price), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, "€ " + _toDisplayString($setup.price), 1),
                  _createElementVNode("span", _hoisted_19, "€ " + _toDisplayString($setup.discountedPrice), 1)
                ])),
            _hoisted_20,
            ($setup.qta === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Sold out"))
              : ($setup.qta <= 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Ne rimangono solo " + _toDisplayString($setup.qta), 1))
                : _createCommentVNode("", true),
            ($setup.qta > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btn btn-icon btn-outline-dark",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.less && $setup.less(...args))),
                    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.less && $setup.less(...args)))
                  }, _hoisted_25, 32),
                  _createElementVNode("span", null, _toDisplayString($setup.counter), 1),
                  _createElementVNode("button", {
                    class: "btn btn-icon btn-outline-dark",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.plus && $setup.plus(...args))),
                    onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.plus && $setup.plus(...args)))
                  }, _hoisted_27, 32)
                ]))
              : _createCommentVNode("", true),
            ($setup.sizes.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sizes, (s) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: s.id,
                      class: _normalizeClass(["btn btn-icon btn-outline-dark", $setup.selectedOption(2, s.id)]),
                      onClick: ($event: any) => ($setup.changeOption(2, s.id)),
                      onKeydown: ($event: any) => ($setup.changeOption(2, s.id))
                    }, _toDisplayString(s.value), 43, _hoisted_29))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            ($setup.colors.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.colors, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c.id,
                      class: _normalizeClass(["btn btn-icon btn-outline-dark", $setup.selectedOption(1, c.id)]),
                      onClick: ($event: any) => ($setup.changeOption(1, c.id)),
                      onKeydown: ($event: any) => ($setup.changeOption(1, c.id))
                    }, _toDisplayString(c.value), 43, _hoisted_31))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            ($setup.materials.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.materials, (m) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: m.id,
                      class: _normalizeClass(["btn btn-icon btn-outline-dark", $setup.selectedOption(3, m.id)]),
                      onClick: ($event: any) => ($setup.changeOption(3, m.id)),
                      onKeydown: ($event: any) => ($setup.changeOption(3, m.id))
                    }, _toDisplayString(m.value), 43, _hoisted_33))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_34,
            ($setup.weight > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", _hoisted_37, _toDisplayString($setup.weight) + " g", 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("p", { innerHTML: $setup.description }, null, 8, _hoisted_40)
                ]))
              : _createCommentVNode("", true),
            ($setup.materials.length === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _hoisted_42,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.materials, (m) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: m.id,
                      class: "weight"
                    }, _toDisplayString(m.value), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            ($setup.sizeGuide === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
              : _createCommentVNode("", true),
            (!$setup.preorder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_50))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_51, [
              ($setup.qta > 0 && $setup.preorder)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-pc btn-pc-preorder",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.addToCart && $setup.addToCart(...args))),
                    onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.addToCart && $setup.addToCart(...args)))
                  }, _hoisted_54, 32))
                : ($setup.qta > 0 && !$setup.preorder)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-pc btn-pc-primary",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.addToCart && $setup.addToCart(...args))),
                      onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.addToCart && $setup.addToCart(...args)))
                    }, _toDisplayString(_ctx.$t('common.addtocart')), 33))
                  : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-pc btn-pc-secondary",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.goToCart && $setup.goToCart(...args))),
                onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.goToCart && $setup.goToCart(...args)))
              }, _toDisplayString(_ctx.$t('common.gotocheckout')), 33)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            ($setup.products.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.products, (p) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      to: { name: 'MerchDetail', params: { id: p.code }},
                      key: p.code,
                      class: "col-12 col-md-6 col-lg-4 merch-products-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MerchItem, { merch: p }, null, 8, ["merch"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}